'use client';

import { useTranslation } from 'react-i18next';

const BRANDS = [
  { key: 'firetv', name: 'Fire TV', logo: '/assets/TVs/display-logos/amazon.svg' },
  { key: 'xiaomi', name: 'Xiaomi', logo: '/assets/TVs/display-logos/xiaomi.svg?v=2' },
  { key: 'hisense', name: 'Hisense', logo: '/assets/TVs/display-logos/hisense.svg' },
  { key: 'philips', name: 'Philips', logo: '/assets/TVs/display-logos/philips.svg' },
  { key: 'tcl', name: 'TCL', logo: '/assets/TVs/display-logos/tcl.svg?v=2' },
  { key: 'thomson', name: 'Thomson', logo: '/assets/TVs/logo-thomson.svg' },
  { key: 'peaq', name: 'PEAQ', logo: '/assets/TVs/logo-peaq.svg' },
  { key: 'google-tv', name: 'Google TV', logo: '/assets/TVs/display-logos/google.svg' },
  { key: 'sony', name: 'Sony', logo: '/assets/TVs/display-logos/sony.svg?v=2' },
];

const MARQUEE_BRANDS = [...BRANDS, ...BRANDS];

const TVs = () => {
  const { t } = useTranslation(['home']);

  return (
    <section className="tvs-section" aria-labelledby="compatible-devices-title" data-home-reveal>
      <svg className="tvs-wave tvs-wave--left" viewBox="0 0 620 310" aria-hidden="true" focusable="false"><path d="M0 0h620c-62 20-90 73-139 126C378 230 207 253 0 160Z" fill="currentColor" /></svg>
      <svg className="tvs-wave tvs-wave--right" viewBox="0 0 620 300" aria-hidden="true" focusable="false"><path d="M620 0H0c102 39 109 118 229 164 113 43 233 28 391-39Z" fill="currentColor" /></svg>
      <div className="tvs-ambient tvs-ambient--left" aria-hidden="true" />
      <div className="tvs-ambient tvs-ambient--right" aria-hidden="true" />
      <div className="container tvs-content">
        <p className="tvs-eyebrow">{t('tvs.eyebrow')}</p>
        <h2 id="compatible-devices-title" className="tvs-title">
          <span>{t('tvs.title_prefix')}</span>{' '}
          <span className="tvs-title-accent">{t('tvs.title_accent')}</span>
        </h2>
        <p className="tvs-description">{t('tvs.description')}</p>
        <div className="tvs-platforms" aria-label={t('tvs.platforms_label')}>
          <span className="tvs-platform-badge"><img className="tvs-platform-icon tvs-platform-icon--android" src="/assets/TVs/android.svg" alt="" /> Android TV</span>
          <span className="tvs-platform-badge tvs-platform-badge--google"><img className="tvs-platform-icon tvs-platform-icon--google" src="/assets/TVs/display-logos/google.svg" alt="" /> Google TV</span>
          <span className="tvs-platform-badge tvs-platform-badge--fire"><img className="tvs-platform-icon tvs-platform-icon--fire" src="/assets/TVs/amazonfiretv.svg" alt="" /> Fire TV</span>
        </div>
      </div>

      <div className="tvs-carousel-shell">
        <div className="tvs-viewport">
          <div className="tvs-track">
            {MARQUEE_BRANDS.map((brand, index) => (
              <div key={`${brand.key}-${index}`} className={`tvs-brand-card tvs-brand-card--${brand.key}`}>
                <img src={brand.logo} alt={brand.name} className="tvs-logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="tvs-more">{t('tvs.more')}</p>
    </section>
  );
};

export default TVs;
